import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShoppingBag3"><Path d="M7.5 11.5V3.5H16.5V11.5M3.5 7.5H20.5V20.5H3.5V7.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShoppingBag3;
